import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const SortIncremental: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 20 20`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.167 5v6.81l-1.494-1.494-1.179 1.178L10 15l3.506-3.506-1.178-1.178-1.495 1.494V5H9.167z"
        fill={color}
      />
    </svg>
  );
};

export default SortIncremental;
